/* eslint-disable @typescript-eslint/no-unused-vars */
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAssignmentReplacePlaceholderAssignment } from 'api/assignment/assignment';
import { AssignmentViewModel } from 'api/model';
import Dropdown from 'components/Dropdown';
import TextButton from 'components/inputs/TextButton';
import ConfirmModal from 'components/Modal/ConfirmModal';
import LoadingSpinner from 'components/spinners/LoadingSpinner';
import useModalStack from 'contexts/modal/useModalStack';
import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  formatDateTime,
  getHoursAndMinutesFromMillisecondsString,
} from 'utils/date-helpers';
import { showException } from 'utils/exception-helper';
import ConfirmReplacePlaceholderCarAssignmentModal from './ConfirmReplacePlacehodlerCarAssignmentModal';

const StyledTextButton = styled(TextButton)`
  margin-left: 0;
  width: 10px;
`;

const AssignmentActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 250px;
  min-width: 150px;
  gap: 5px;
  padding: 5px;
  text-align: left;
  word-wrap: break-word;
  white-space: normal;
  text-align: left;
`;

type Props = {
  currentAssignment: AssignmentViewModel;
  selectedAssignment: AssignmentViewModel;
};

const ReplacePlaceholderAssignmentActionDropdown: React.FC<Props> = ({
  currentAssignment,
  selectedAssignment,
}) => {
  const modalStack = useModalStack();

  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);

  const diffInEstimatedDuration = useMemo(() => {
    if (
      !currentAssignment.assignment.estimatedDuration ||
      !selectedAssignment.assignment.estimatedDuration
    ) {
      return undefined;
    }
    return (
      selectedAssignment.assignment.estimatedDuration -
      currentAssignment.assignment.estimatedDuration
    );
  }, [
    currentAssignment.assignment.estimatedDuration,
    selectedAssignment.assignment.estimatedDuration,
  ]);

  const handleLostFocus = () => {
    if (dropdownOpen) {
      setDropdownOpen(false);
    }
  };

  const handleAssignUser = () => {
    modalStack.push(
      <ConfirmReplacePlaceholderCarAssignmentModal
        selectedAssignment={selectedAssignment}
        currentAssignment={currentAssignment}
        onCancel={() => {
          modalStack.pop();
          setDropdownOpen(false);
        }}
      />
    );
  };

  return (
    <Dropdown
      content={
        dropdownOpen && (
          <AssignmentActionsWrapper>
            <StyledTextButton onClick={handleAssignUser}>
              Välj bil
            </StyledTextButton>
            {diffInEstimatedDuration === undefined && (
              <span>
                * Estimerad uppdragstid för det nya uppdraget är okänd.
              </span>
            )}
            {diffInEstimatedDuration !== undefined &&
              diffInEstimatedDuration > 0 && (
                <span>
                  * Estimerad uppdragstid för det nya uppdraget är{' '}
                  {getHoursAndMinutesFromMillisecondsString(
                    Math.abs(diffInEstimatedDuration)
                  )}{' '}
                  längre än det nuvarande uppdraget.
                </span>
              )}
          </AssignmentActionsWrapper>
        )
      }
      onClick={() => {
        setDropdownOpen(true);
      }}
      onLostFocus={handleLostFocus}
      position="left"
    >
      <TextButton
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setDropdownOpen(!dropdownOpen);
        }}
      >
        <FontAwesomeIcon icon={faEllipsisV} />
      </TextButton>
    </Dropdown>
  );
};

export default ReplacePlaceholderAssignmentActionDropdown;
